module.exports = __webpack_public_path__ + "img/diners-club.18034586.png";